import actions from "./actions";

const {FETCH_REPORT_MOCK} = actions;
const initState = {
    mock: [],
};

const MockReducer = (state = initState, action) => {
    const {type, data} = action;
    switch (type) {
        case FETCH_REPORT_MOCK:
            return {
                ...state,
                mock: data
            }
        default:
            return state;
    }
}

export default MockReducer;
